import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import DangerButton from '../atoms/DangerButton'
import SecondaryButton from '../atoms/SecondaryButton'

interface UnsavedChangesModalProps {
  isOpen: boolean
  title: string
  body: string
  leaveLabel: string
  stayLabel: string
  onLeave: () => void
  onStay: () => void
}

const modalShadow =
  '0px 16px 32px 0px rgba(0,0,0,0.08), 0px 8px 16px 0px rgba(0,0,0,0.08), 0px 0px 0px 1px rgba(0,0,0,0.08), inset 0px 0px 0px 1.5px rgba(228,228,231,0.60), inset 0px 0px 0px 1px rgba(255,255,255,1.00)'

const UnsavedChangesModal = ({
  isOpen,
  title,
  body,
  leaveLabel,
  stayLabel,
  onLeave,
  onStay
}: UnsavedChangesModalProps): JSX.Element => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        onStay()
      }
    }

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, onStay])

  if (!isOpen) {
    return <></>
  }

  return createPortal(
    <div className="fixed inset-0 z-[400] bg-black/30 flex justify-center items-center p-2.5">
      <button type="button" className="absolute inset-0" aria-label={stayLabel} onClick={onStay} />
      <div
        className="relative z-10 w-[560px] bg-backgrounds-bg-base rounded-lg flex flex-col justify-start items-center overflow-hidden"
        style={{ boxShadow: modalShadow }}>
        <div className="self-stretch px-6 pt-5 pb-6 bg-backgrounds-bg-base flex flex-col justify-start items-start gap-8 overflow-hidden">
          <div className="self-stretch flex flex-col justify-start items-start gap-2">
            <div className="self-stretch text-foregrounds-fg-base text-lg font-semibold font-Montserrat leading-5">
              {title}
            </div>
            <div className="self-stretch text-foregrounds-fg-subtle text-xl font-medium font-Montserrat leading-5">
              {body}
            </div>
          </div>
        </div>
        <div className="self-stretch bg-backgrounds-bg-base flex flex-col justify-center items-center">
          <div className="self-stretch px-6 py-4 flex flex-col justify-end items-end gap-2 overflow-hidden">
            <div className="inline-flex justify-end items-center gap-2">
              <DangerButton onClick={onLeave}>{leaveLabel}</DangerButton>
              <SecondaryButton onClick={onStay}>{stayLabel}</SecondaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default UnsavedChangesModal
